export const FOUNDED_YEAR = 2011;
export const MEDIA_AGE = new Date().getFullYear() - FOUNDED_YEAR;

export const SOCIALS = [
  { key: "instagram", label: "Instagram", href: "https://instagram.com/lgtdz" },
  { key: "youtube", label: "YouTube", href: "https://www.youtube.com/channel/UCeDAnh2mjNEM6fliMvbBNTw" },
  { key: "soundcloud", label: "SoundCloud", href: "https://soundcloud.com/lgtz" },
  { key: "twitch", label: "Twitch", href: "https://www.twitch.tv/lgtdz" },
  { key: "facebook", label: "Facebook", href: "https://www.facebook.com/legrostasdezik" },
];
